import { assign, createMachine, DoneInvokeEvent } from 'xstate';
import {
  ChangePlanPreview,
  Context,
  ErrorTypes,
  Events,
  Product,
} from './types';

const initialContext: Context = {
  products: null,
  selectedPlan: null,
  changePlanPreview: null,
  threeDsActionLink: null,
  error: null,
};
export const changePlan = createMachine<Context, Events>({
  id: 'changePlan',
  predictableActionArguments: true,
  initial: 'configurePlanStep',
  context: {
    ...initialContext,
  },
  states: {
    configurePlanStep: {
      id: 'configurePlanStep',
      initial: 'idle',
      states: {
        idle: {
          on: {
            GET_PRODUCTS: 'getProducts',
          },
        },
        getProducts: {
          invoke: {
            src: 'getProducts',
            onDone: {
              actions: (ctx, event: DoneInvokeEvent<{ items: Product[] }>) =>
                (ctx.products = event.data.items),
              target: 'ready',
            },
            onError: {
              target: 'error',
            },
          },
        },
        ready: {
          on: {
            SELECT_PLAN: {
              actions: assign((context, event) => {
                return {
                  selectedPlan: event.planId,
                };
              }),
            },
            GET_PREVIEW_PRODUCT_MIGRATION: 'getPreviewProductMigration',
          },
        },
        getPreviewProductMigration: {
          invoke: {
            src: 'previewProductMigration',
            onDone: {
              actions: (ctx, event: DoneInvokeEvent<ChangePlanPreview>) =>
                (ctx.changePlanPreview = event.data),
              target: '#previewProductMigrationStep',
            },
            onError: {
              target: 'error',
            },
          },
        },
        error: {},
      },
    },
    previewProductMigrationStep: {
      id: 'previewProductMigrationStep',
      initial: 'idle',
      states: {
        idle: {
          on: {
            CONFIRM_CHANGE_PLAN: 'confirmProductMigration',
            GO_BACK: '#configurePlanStep.ready',
          },
        },
        confirmProductMigration: {
          invoke: {
            src: 'confirmProductMigration',
            onDone: {
              actions: ['updateSubscription', 'onSuccess'],
              target: 'success',
            },
            onError: [
              {
                target: 'threeDsConfirmation',
                actions: [
                  assign((context, event) => ({
                    threeDsActionLink: event.data.threeDsActionLink,
                    error: event.data.errorCode,
                  })),
                  'onThreeDsConfirmation',
                ],
                cond: (c, e) =>
                  e.data.threeDsActionLink &&
                  e.data.errorCode === '3DSecureAuthentication',
              },
              {
                target: 'error',
                actions: assign((context, event) => ({
                  error: event.data.errorCode,
                })),
                cond: (c, e) => e.data.errorCode === 'CardDeclined',
              },
              {
                target: 'error',
                actions: assign(() => ({
                  error: 'Generic' as ErrorTypes,
                })),
              },
            ],
          },
        },
        success: {
          type: 'final',
        },
        error: {
          type: 'final',
        },
        threeDsConfirmation: {
          type: 'final',
        },
      },
    },
  },
});
